/**
 * trackBy helpers.
 *
 * Without one, *ngFor rebuilds every row whenever the array instance changes, even
 * if the contents are the same objects. That is cheap for a handful of buttons and
 * expensive for the area lists, which run to thousands of rows at practice level.
 */
export const trackByAreaId = (index: number, item: any): any => item?.AreaID ?? index;
export const trackByIndicatorId = (index: number, item: any): any => item?.IndicatorID ?? index;
export const trackByPeriodId = (index: number, item: any): any => item?.TimePeriodID ?? index;
export const trackBySystemLevelId = (index: number, item: any): any => item?.SystemLevelID ?? index;
export const trackByMetricId = (index: number, item: any): any => item?.MetricID ?? index;
export const trackByIndex = (index: number): number => index;
/** For the keyvalue pipe, which builds a fresh wrapper object on every run. */
export const trackByKey = (index: number, item: any): any => item?.key ?? index;
export const trackByValue = (index: number, item: any): any => item ?? index;
